import { render, staticRenderFns } from "./ModalAdicionarTime.vue?vue&type=template&id=6fb12ff2&scoped=true&"
import script from "./ModalAdicionarTime.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarTime.vue?vue&type=script&lang=js&"
import style0 from "./ModalAdicionarTime.vue?vue&type=style&index=0&id=6fb12ff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb12ff2",
  null
  
)

export default component.exports